import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/ui/button";

/**
 * LoginButton Component
 *
 * Button that triggers Auth0 login flow.
 * Can be used anywhere in the app where login is needed.
 */
export function LoginButton() {
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = () => {
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
    loginWithRedirect({
      authorizationParams: {
        audience,
        scope: "openid profile email",
      },
      appState: {
        returnTo: window.location.pathname,
      },
    });
  };

  return (
    <Button onClick={handleLogin} disabled={isLoading} size="lg">
      {isLoading ? "Loading..." : "Log In"}
    </Button>
  );
}
